import Styles from './breadcrumb-styles.scss';
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
const Breadcrumb = ({ data }) => {
    return (React.createElement("div", { className: classNames(Styles.breadcrumbContainer) }, data.map(data => {
        if (data.link) {
            return (React.createElement(Link, { key: data.id, to: `/${data.link}`, className: classNames(Styles.link, data.link && Styles.linkColor) },
                data.text,
                " ",
                data.link && React.createElement("span", { className: Styles.arrow }, '>')));
        }
        return (React.createElement("span", { key: data.id, className: classNames(Styles.link, data.link && Styles.linkColor) },
            data.text,
            " ",
            data.link && React.createElement("span", { className: Styles.arrow }, '>')));
    })));
};
export default Breadcrumb;
